<div class="pt-12 pb-6 px-3 container m-auto flex flex-row justify-between ">

  <div class="text-muted grow">
    Copyright {{year}}, groupworkguru.com
  </div>

  <div class="flex flex-row gap-3 text-center">
    <a href="/privacy">Privacy Policy</a>
    <a href="/terms">Terms of Use</a>
    <a href="mailto:info@groupworkguru.com">Contact Us</a>
  </div>
</div>
